<template>
  <button class="button-black-big w-60 h-12 text-sm border-black border rounded-sm">
    <slot />
  </button>
</template>

<script lang="ts" setup>

</script>

<style scoped lang="scss">
.button-black-big {
  transition: all linear .3s;

  &:hover {
    background: rgba(235,235,237,.3);
  }
}
</style>
